// 使用 any 绕过严格的 TS 检查，无需修改原有的 types 文件
export function useServerWebSocket(serversRef: any, wsBaseUrl: string) {
    const wsMap = new Map<string, WebSocket>();

    // 🌟 关键修改：接收 serverId (用于连接和 DO 匹配) 和 serverName (用于日志)
    const connect = (serverId: string, serverName: string) => {
        if (wsMap.has(serverId)) return;

        // 使用 serverId 建立连接，确保与 Go 探针的 X-Server-ID 完全一致
        const ws = new WebSocket(`${wsBaseUrl}/ws?id=${serverId}`);

        ws.onopen = () => {
            console.log(`[WS] ✅ 已连接到: ${serverName} (ID: ${serverId})`);
        };

        ws.onmessage = (event) => {
            try {
                const newData = JSON.parse(event.data);

                // 🌟 添加调试日志，确认收到的数据是否包含 updated_at
                console.log(`[WS] 收到 ${newData.name} 的数据, updated_at:`, newData.updated_at);

                // 优先使用 id 匹配，如果没有 id 则 fallback 到 name 匹配
                const index = serversRef.value.findIndex((s: any) =>
                    (s.id && s.id === newData.id) || s.name === newData.name
                );

                if (index !== -1) {
                    // 强制触发 Vue 响应式更新
                    serversRef.value[index] = { ...serversRef.value[index], ...newData };
                    console.log(`[WS] ✅ 成功更新: ${newData.name}`);
                } else {
                    console.warn(`[WS] ⚠️ 未找到匹配的服务器！收到的 name: ${newData.name}, id: ${newData.id}`);
                    console.warn('[WS] 当前服务器列表:', serversRef.value.map((s: any) => ({ name: s.name, id: s.id })));
                }
            } catch (e) {
                console.error('[WS] 数据解析错误:', e);
            }
        };

        ws.onclose = () => {
            console.log(`[WS] ⚠️ 与 ${serverName} (ID: ${serverId}) 断开连接，3秒后尝试重连...`);
            wsMap.delete(serverId);
            setTimeout(() => connect(serverId, serverName), 3000); // 3秒后自动重连
        };

        ws.onerror = (err) => {
            console.error(`[WS] ❌ ${serverName} (ID: ${serverId}) 连接错误:`, err);
            ws.close(); // 触发 onclose 进行重连
        };

        // 🌟 使用 serverId 作为 Map 的 key
        wsMap.set(serverId, ws);
    };

    // 清理所有连接的函数
    const disconnectAll = () => {
        wsMap.forEach(ws => ws.close());
        wsMap.clear();
        console.log('[WS] 🧹 已清理所有 WebSocket 连接');
    };

    return {
        connect,
        disconnectAll
    };
}